import { getNiceDate, getNiceNumber } from '@/lib/helpers';
import { isValidElement, ReactNode } from 'react';

type ReadonlyPropType = 'string' | 'date' | 'section';

export type ReadonlyField = {
  label: string;
  prop: string;
  propType?: ReadonlyPropType;
  rowGroup?: string; // Optional grouping for layout
};

export const processCompDataValue = (rawVal: unknown, propType?: ReadonlyPropType): ReactNode => {
  switch (typeof rawVal) {
    case 'string':
      return rawVal;
    case 'number':
      return getNiceNumber(Number(rawVal));
    case 'boolean':
      return rawVal ? 'Yes' : 'No';
    case 'object':
      if (rawVal === null) {
        return '';
      } else if (isValidElement(rawVal)) {
        return rawVal;
      } else if (propType === 'date') {
        return getNiceDate(rawVal as Date).formatted;
      }
      return '';
    default:
      return '';
  }
};
